module.exports = __webpack_public_path__ + "static/media/BFI-BNB.8982757f.svg";